"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceParam = void 0;

function replaceParam(params, name, newValues) {
  params.delete(name);
  newValues.forEach(function (it) {
    return params.append(name, it);
  });
}

exports.replaceParam = replaceParam;